import { all } from "redux-saga/effects";

import getMenuSaga from "./getMenu";
import getDetail from "./getDetail";
import getListAuthorizationDocs from "./getListAuthorizationDocs";

export default function* authorizationDocumentSaga() {
  yield all([getMenuSaga(), getDetail(), getListAuthorizationDocs()]);
}
